import formInput from '@/components/common/form-input/form-input.vue'
import formSelect from '@/components/common/form-select/form-select.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import softApproval from '@/components/common/soft-approval/soft-approval.vue'
import Multiselect from 'vue-multiselect'
import { mapState, mapActions, mapGetters } from 'vuex'
import permissionRow from '@/components/pages/page-templates/create-update-competition/create-update-competition-content/permissionRow/permissionRow.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment-timezone'
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate'
import modal from '@/components/common/modal/modal.vue'

export default {
  components: {
    modal,
    formInput,
    formSelect,
    formButton,
    Multiselect,
    softApproval,
    permissionRow,
    flatPickr
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    owner: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    core: {
      type: Object
    },
    template: {
      type: Object,
      required: true
    },
    status: {
      type: String
    }
  },
  data() {
    return {
      admins: [],
      competitionName: this.name,
      countries: [],
      datetimePickerOptions: {
        enableTime: true,
        time_24hr: true,
        dateFormat: 'Y-m-d H:i',
        plugins: [new ConfirmDatePlugin({})],
        allowInput: true
      },
      end_date: null,
      errMsg: '',
      headers: ['', 'Name', 'Read / Write', 'Read Only', 'No Access'],
      newOwner: {},
      selectedAdmin: null,
      selectedCountries: [],
      selectedTimezone: null,
      start_date: null,
      timezones: moment.tz.names(),
      usersRoles: []
    }
  },
  watch: {
    'newOwner.user_id': function (val) {
      this.users.filter((user) => user.user_id === val)[0].role = 'editor'
    }
  },
  computed: {
    ...mapState('popup', ['currentPopup']),
    ...mapState('competition', ['newCompetition']),
    ...mapState('countries', ['countriesList']),
    ...mapState('template', ['ageOptions', 'searchParams']),
    ...mapGetters('user', ['isAdmin']),
    privileges: function () {
      return this.users.map((user) => {
        let obj = {}
        obj.role = user.role
        obj.user_id = user.user_id || user.id
        return obj
      })
    },
    isFormFilled: function () {
      let date =
        this.start_date &&
        this.end_date &&
        this.end_date > this.start_date &&
        !this.isStartDateInPast &&
        !this.isEndDataErrorVisible
      let delay = this.core.archive_delay_months > 0 && this.core.archive_delay_months <= 100
      return Boolean(
        this.competitionName &&
          date &&
          delay &&
          this.selectedCountries[0] &&
          this.competitionName.length < 77 &&
          this.selectedTimezone
      )
    },
    isFormDisabled: function () {
      return this.status && this.status.length > 0 && this.status !== 'draft'
    },
    minDate: function () {
      return this.selectedTimezone ? moment().tz(this.selectedTimezone).format() : moment().format()
    },
    minDateForEndDate: function () {
      return moment(this.start_date).isValid() ? this.start_date : this.minDate
    },
    startDateConfig: function () {
      return Object.assign({}, this.datetimePickerOptions, { minDate: this.isFormDisabled ? null : this.minDate })
    },
    endDateConfig: function () {
      return Object.assign({}, this.datetimePickerOptions, { minDate: this.minDateForEndDate })
    },
    isEndDataErrorVisible: function () {
      return Boolean(moment(this.start_date) >= moment(this.end_date))
    },
    isStartDateInPast: function () {
      return Boolean(
        this.start_date && moment.tz(this.start_date, this.selectedTimezone) < moment().tz(this.selectedTimezone)
      )
    }
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['getUser', 'getUsers']),
    ...mapActions('template', ['getAssignedCountries']),
    adjustDateWithTimezone: function (date) {
      return moment.tz(date, this.selectedTimezone).format()
    },
    showAlternativeDatePopup: function () {
      if (this.core.alternative_data_retention) {
        this.setCurrentPopup('alternativeData')
      }
    },
    changeRetention: function (value) {
      if (!value) {
        this.core.alternative_data_retention = false
      }
      this.setCurrentPopup(null)
    },
    onNextClick: function () {
      if (this.isFormFilled) {
        if (this.template.soft_approval) {
          this.setCurrentPopup('softApproval')
        } else {
          this.submitCompetition()
        }
      }
    },
    submitCompetition: function (email) {
      this.selectedAdmin = email
      this.$emit('onNextClick', {
        competition: {
          ...(this.selectedAdmin && { approval_email: this.selectedAdmin.email }),
          owner: this.newOwner.user_id || this.newOwner.id,
          template: this.template,
          core: {
            name: this.competitionName,
            description: this.competitionName,
            start_date: this.adjustDateWithTimezone(this.start_date),
            end_date: this.adjustDateWithTimezone(this.end_date),
            countries: this.selectedCountries,
            timezone: this.selectedTimezone,
            archive_delay_months: this.core.archive_delay_months,
            alternative_data_retention: this.isAdmin ? false : this.core.alternative_data_retention
          }
        },
        privileges: this.privileges
      })
    },
    cancel: function () {
      this.setCurrentPopup(null)
      this.selectedAdmin = null
    }
  },
  async created() {
    this.newOwner = Object.assign({}, this.owner)
    this.selectedTimezone = this.core.timezone
    this.start_date = this.adjustDateWithTimezone(this.core.start_date)
    this.end_date = this.adjustDateWithTimezone(this.core.end_date)
    this.competitionName = this.core.name || this.competitionName
    this.selectedCountries = this.core.countries
    const countries = this.isAdmin ? this.countriesList : await this.getAssignedCountries({ id: this.template.id })
    this.countries = countries.map((country) => country.name)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-templates/create-update-competition/create-update-competition-content/create-update-competition-content.js